(function () {
  var FOOTER_INSET_PX = 16;
  var lastScrollY = window.scrollY;
  var threshold = 8;
  var atBottomTolerance = 4;

  function onScroll() {
    var footer = document.querySelector('.footer');
    if (!footer) return;
    var currentScrollY = window.scrollY;
    var delta = currentScrollY - lastScrollY;
    var atPageBottom = (window.innerHeight + currentScrollY) >= (document.documentElement.scrollHeight - atBottomTolerance);

    if (atPageBottom) {
      footer.classList.remove('oi-footer--hidden');
    } else if (Math.abs(delta) > threshold) {
      if (delta > 0 && currentScrollY > 40) {
        footer.classList.add('oi-footer--hidden');
      } else if (delta < 0) {
        footer.classList.remove('oi-footer--hidden');
      }
      lastScrollY = currentScrollY;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });

  function layoutFooterBlocks() {
    var footer = document.querySelector('.footer');
    var content = document.querySelector('.footer__content-top');
    var wrapper = document.querySelector('.footer__blocks-wrapper');
    if (!wrapper) return;
    var blocks = wrapper.querySelectorAll(':scope > .footer-block');

    if (window.innerWidth < 750) {
      if (footer) {
        footer.style.setProperty('padding-left', '0px', 'important');
        footer.style.setProperty('padding-right', '0px', 'important');
      }
      if (content) {
        content.style.setProperty('width', '100%', 'important');
        content.style.setProperty('padding-left', FOOTER_INSET_PX + 'px', 'important');
        content.style.setProperty('padding-right', FOOTER_INSET_PX + 'px', 'important');
      }
      wrapper.style.setProperty('display', 'flex', 'important');
      wrapper.style.setProperty('flex-direction', 'row', 'important');
      wrapper.style.setProperty('justify-content', 'space-between', 'important');
      wrapper.style.setProperty('align-items', 'flex-end', 'important');
      wrapper.style.setProperty('flex-wrap', 'nowrap', 'important');
      wrapper.style.setProperty('width', '100%', 'important');
      wrapper.style.setProperty('gap', '12px', 'important');
      blocks.forEach(function (b, i) {
        b.style.setProperty('width', 'auto', 'important');
        b.style.setProperty('max-width', 'none', 'important');
        b.style.setProperty('flex', '0 0 auto', 'important');
        b.style.setProperty('padding-left', '0px', 'important');
        b.style.setProperty('padding-right', '0px', 'important');
        b.style.setProperty('margin-left', '0px', 'important');
        b.style.setProperty('margin-right', '0px', 'important');
        if (i === blocks.length - 1) {
          b.style.setProperty('text-align', 'right', 'important');
        }
      });
    } else {
      if (footer) {
        footer.style.removeProperty('padding-left');
        footer.style.removeProperty('padding-right');
      }
      if (content) {
        content.style.removeProperty('width');
        content.style.removeProperty('padding-left');
        content.style.removeProperty('padding-right');
      }
      wrapper.style.removeProperty('display');
      wrapper.style.removeProperty('flex-direction');
      wrapper.style.removeProperty('justify-content');
      wrapper.style.removeProperty('align-items');
      wrapper.style.removeProperty('flex-wrap');
      wrapper.style.removeProperty('width');
      wrapper.style.removeProperty('gap');
      blocks.forEach(function (b) {
        b.style.removeProperty('width');
        b.style.removeProperty('max-width');
        b.style.removeProperty('flex');
        b.style.removeProperty('text-align');
        b.style.removeProperty('padding-left');
        b.style.removeProperty('padding-right');
        b.style.removeProperty('margin-left');
        b.style.removeProperty('margin-right');
      });
    }
  }

  layoutFooterBlocks();
  setInterval(layoutFooterBlocks, 500);
  window.addEventListener('resize', layoutFooterBlocks, { passive: true });
})();
